import { em, rem } from 'polished'
import styled from 'styled-components'

export interface IStepCountStepsStyledProps {
  clickable?: boolean
}

export const BaseStepCountStepsListStyled = styled.ul<IStepCountStepsStyledProps>`
  font-size: ${rem(16)};
`
